import { createTemporaryId } from "../utils/model";

export class UserCohearingSession {
  readonly id: string = createTemporaryId();
  readonly takeoverAt?: Date;
  
  constructor(deriveFrom?: Partial<UserCohearingSession>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.takeoverAt) {
      this.takeoverAt = new Date(this.takeoverAt);
    }
  }
}